// src/hooks/useLoadNotifications.ts

import { useMemo, useEffect } from "react";

import { useNotificationPortal } from "@context/notification/hook/useNotificationPortal";

export const useLoadNotifications = () => {
  const {
    state: { notifications },
    action: { autoFetchGetNotificationsReadUnread },
  } = useNotificationPortal();

  useEffect(() => {
    void autoFetchGetNotificationsReadUnread();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const unreadCount = useMemo(
    () => notifications.filter((n) => !n.readAt).length,
    [notifications]
  );

  return {
    notifications,
    unreadCount,
    hasUnread: unreadCount > 0,
  };
};

export default useLoadNotifications;
